export const bytesToMegaBytes = (bytes: number) => bytes / 1048576;

export const megaBytesToBytes = (megaBytes: number) => megaBytes * 1024 * 1024;
